// CDN paths — environment-specific, set via REACT_APP_ env vars at build time
// Beta (default):  pmp_v3/development, patch_code/beta
// Production:      pmp_v3/production,  patch_code

const CDN_BASE = 'https://man.vm5apis.com';

const PMP_ENV = process.env.REACT_APP_PMP_ENV || 'development';
// 'development' for beta, 'production' for prod

const PATCH_PREFIX = process.env.REACT_APP_PATCH_PREFIX || 'beta/';
// 'beta/' for beta, '' for prod

export const demoLink = (creativeUuid, placementType) =>
  `${CDN_BASE}/dist/pmp_v3/${PMP_ENV}/mobile-demo.html?cid=${encodeURIComponent(creativeUuid)}&ct=${encodeURIComponent(placementType)}`;

export const CDN = {
  META_LIST: `${CDN_BASE}/dist/pmp_v3/${PMP_ENV}/VM5Series/meta_list.js`,
  PREVIEW: `${CDN_BASE}/dist/pmp_v3/${PMP_ENV}/v3.2/preview.html`,
  AD_LITE: `${CDN_BASE}/dist/pmp_v3/${PMP_ENV}/VM5AdLite.js`,
  PREVIEW_ORIGIN: `${CDN_BASE}/`,
  appPatch: (appId, placementType) =>
    `${CDN_BASE}/patch_code/${PATCH_PREFIX}app/${appId}/${placementType}_patch.js`,
  placementPatch: (placementUuid) =>
    `${CDN_BASE}/patch_code/${PATCH_PREFIX}placement/${placementUuid}.js`,
};
